/* COMING SOON / pre-order behaviour for product pages (Camo Capsule, Nov 2026).

   main-product.liquid loads this only for products tagged "coming-soon".
   Three jobs: the release countdown, the signup box that replaces Add to
   cart, and keeping Klaviyo's own popups off a page that already asks for
   an email. */

(function () {
  // ---- Countdown: TT:HH:MM:SS, hides itself once the release has passed ----

  class ComingSoonCountdown extends HTMLElement {
    connectedCallback() {
      const releaseMs = Number(this.dataset.releaseTs) * 1000;
      this.output = this.querySelector('[data-countdown]');

      if (!releaseMs || !this.output) {
        this.hidden = true;
        return;
      }

      this.releaseMs = releaseMs;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const diff = this.releaseMs - Date.now();

      // Nothing stale after 15:00: the whole block goes, not just the digits.
      if (diff <= 0) {
        clearInterval(this.timer);
        this.hidden = true;
        return;
      }

      const pad = (n) => String(n).padStart(2, '0');
      const days = Math.floor(diff / 864e5);
      const hours = Math.floor((diff % 864e5) / 36e5);
      const minutes = Math.floor((diff % 36e5) / 6e4);
      const seconds = Math.floor((diff % 6e4) / 1e3);

      this.output.textContent = `${pad(days)}:${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    }
  }

  if (!customElements.get('coming-soon-countdown')) {
    customElements.define('coming-soon-countdown', ComingSoonCountdown);
  }

  // ---- Signup: Klaviyo client subscriptions API --------------------------
  //
  // Posts straight to Klaviyo's public (client-side) endpoint; the company id
  // is the same public key theme.liquid initialises onsite tracking with, so
  // nothing secret lives in the theme. The four properties are what makes the
  // list reportable per product and colour later. A duplicate signup also
  // answers 202, which is exactly what we want: no error for a returning
  // visitor.

  class ComingSoonSignup extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="email"]');
      this.button = this.querySelector('button[type="submit"]');
      this.message = this.querySelector('[data-signup-message]');

      if (!this.form || !this.input || !this.button) return;

      this.form.addEventListener('submit', (event) => this.submit(event));
    }

    show(text, kind) {
      if (!this.message) return;
      this.message.textContent = text;
      this.message.classList.toggle('coming-soon-signup__message--error', kind === 'error');
      this.message.classList.toggle('coming-soon-signup__message--success', kind === 'success');
    }

    async submit(event) {
      event.preventDefault();

      const email = this.input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.show(this.dataset.invalidText, 'error');
        this.input.focus();
        return;
      }

      this.button.disabled = true;
      this.show('', '');

      const d = this.dataset;
      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: d.source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    Source: d.source,
                    product_title: d.productTitle,
                    product_color: d.productColor,
                    product_handle: d.productHandle,
                  },
                  subscriptions: {
                    email: { marketing: { consent: 'SUBSCRIBED' } },
                  },
                },
              },
            },
          },
          relationships: {
            list: { data: { type: 'list', id: d.listId } },
          },
        },
      };

      try {
        const response = await fetch(
          `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(d.companyId)}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              // Revisions before 2025-01-15 reject the nested "subscriptions"
              // object ("'subscriptions' is not a valid field for the
              // resource 'profile'"); 2025-01-15 and later accept it.
              revision: '2025-10-15',
            },
            body: JSON.stringify(payload),
          }
        );

        if (response.ok) {
          this.show(d.successText, 'success');
          this.form.hidden = true;
          return;
        }

        let detail = '';
        try {
          const body = await response.json();
          detail = (body.errors && body.errors[0] && body.errors[0].detail) || '';
        } catch (e) {
          /* no JSON body — fall through to the generic text */
        }
        this.show(detail || d.errorText, 'error');
      } catch (e) {
        this.show(d.errorText, 'error');
      } finally {
        this.button.disabled = false;
      }
    }
  }

  if (!customElements.get('coming-soon-signup')) {
    customElements.define('coming-soon-signup', ComingSoonSignup);
  }

  // ---- No Klaviyo popups on this page ------------------------------------
  //
  // The first-order popup competes with the signup box and would blur the
  // list's reporting. Klaviyo announces every form it opens on window; we
  // close it again through its documented queue before it can draw. The
  // targeting rule in the Klaviyo form itself (exclude this URL path) is the
  // belt to this braces — set both.

  window._klOnsite = window._klOnsite || [];
  window.addEventListener('klaviyoForms', (event) => {
    const detail = event.detail || {};
    if (detail.type !== 'open' || !detail.formId) return;
    window._klOnsite.push(['closeForm', detail.formId]);
  });
})();
